import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/app/AppShell";
import { api } from "../lib/api";
import { useT } from "../contexts/LanguageContext";
import { toast } from "sonner";
import { ClockClockwise, Sparkle } from "@phosphor-icons/react";

export default function Review() {
  const { t, lang } = useT();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/review/stats");
        setStats(data);
      } catch {
        setStats({ total: 0, due: 0 });
      }
    })();
  }, []);

  const start = async () => {
    setStarting(true);
    try {
      const { data } = await api.post("/quiz/start", {
        mode: "review",
        count: Math.min(stats?.due || 20, 20),
        lang,
      });
      navigate("/quiz/run", { state: { quiz: data, mode: "review" } });
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("review.could_not_start"));
    } finally {
      setStarting(false);
    }
  };

  return (
    <AppShell>
      <div className="overline text-[#002FA7]">{t("review.overline")}</div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-1">{t("review.title")}</h1>
      <p className="text-slate-600 mt-2 max-w-xl">{t("review.subtitle")}</p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl">
        <div className="card">
          <div className="overline">{t("review.due")}</div>
          <div className="font-display text-5xl font-bold text-[#E11D48] mt-2" data-testid="review-due-count">{stats?.due ?? "—"}</div>
        </div>
        <div className="card">
          <div className="overline">{t("review.total")}</div>
          <div className="font-display text-5xl font-bold text-[#002FA7] mt-2" data-testid="review-total-count">{stats?.total ?? "—"}</div>
        </div>
        <div className="card">
          <div className="overline flex items-center gap-1 text-[#002FA7]"><Sparkle size={12} weight="fill" /> SM-2</div>
          <p className="text-sm text-slate-600 mt-2 leading-relaxed">
            {lang === "tr"
              ? "Doğru cevaplandığında aralık katlanır; yanlışta 1 güne düşer."
              : "Correct answers exponentially extend the interval; wrong ones reset to 1 day."}
          </p>
        </div>
      </div>

      <div className="mt-8 flex items-center gap-3">
        {stats && stats.due === 0 ? (
          <div className="ai-callout text-sm">{t("review.empty")}</div>
        ) : (
          <button onClick={start} disabled={starting || !stats || stats.due === 0} className="btn-primary inline-flex items-center gap-2" data-testid="review-start-button">
            <ClockClockwise size={16} weight="bold" /> {starting ? t("review.starting") : t("review.start")}
          </button>
        )}
      </div>
    </AppShell>
  );
}
